export default "__VITE_ASSET__Cc2n7b9q__"